import { notificationService } from '@app/services/notification.service';
import {
	financeByEDilo,
	getEDiloLimits,
	submitEDilo,
} from '@FW/features/eDilo/api/eDilo.transport';
import {
	IEDiloCreatePayload,
	IEDiloCreateResult,
	IEDiloFinanceResult,
	IEDiloLimits,
	StdApiError,
} from '@FW/features/eDilo/api/eDilo.types';
import { useAppSelector } from '@hooks/shared/reduxHooks';
import { useMutation, useQuery } from '@tanstack/react-query';
import { t } from 'i18next';

export const useEDiloLimits = () => {
	const isAuth = useAppSelector((s) => s.auth.isAuth);
	const counterparty = useAppSelector((s) => s.user.client?.counterparty);

	return useQuery<IEDiloLimits, StdApiError>({
		queryKey: ['edilo', 'limits', counterparty],
		queryFn: () => getEDiloLimits(counterparty!),
		enabled: isAuth && !!counterparty,
	});
};

export const useSubmitEDilo = () => {
	const counterparty = useAppSelector((s) => s.user.client?.counterparty);

	return useMutation<IEDiloCreateResult, StdApiError, IEDiloCreatePayload>({
		mutationFn: (payload) => submitEDilo(counterparty!, payload),
		onError: (err) => notificationService.error({ message: err.message || t('api.error') }),
	});
};

export const useFinanceByEDilo = () => {
	const counterparty = useAppSelector((s) => s.user.client?.counterparty);

	return useMutation<IEDiloFinanceResult, StdApiError, string>({
		mutationFn: (invoiceId) => financeByEDilo(counterparty!, invoiceId),
		onError: (err) => notificationService.error({ message: err.message || t('api.error') }),
	});
};
